import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function EyeIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 36}
      height={height || 24}
      viewBox="0 0 18 12"
    >
      <path
        id="Caminho_10275"
        data-name="Caminho 10275"
        d="M17.891-6.456A10.023,10.023,0,0,0,9-12,10.024,10.024,0,0,0,.109-6.456,1.2,1.2,0,0,0,0-6a1.2,1.2,0,0,0,.109.456A10.023,10.023,0,0,0,9,0a10.024,10.024,0,0,0,8.891-5.544A1.2,1.2,0,0,0,18-6,1.2,1.2,0,0,0,17.891-6.456ZM9-1.5A4.5,4.5,0,0,1,4.5-6,4.5,4.5,0,0,1,9-10.5,4.5,4.5,0,0,1,13.5-6v0A4.5,4.5,0,0,1,9-1.5ZM9-9a3.576,3.576,0,0,0-.791.118A1.748,1.748,0,0,1,8.5-8,1.5,1.5,0,0,1,7-6.5a1.748,1.748,0,0,1-.886-.291,3.593,3.593,0,0,0-.1.784A2.994,2.994,0,0,0,9.007-3.014,2.994,2.994,0,0,0,12-6.007,2.994,2.994,0,0,0,9.007-9Z"
        transform="translate(0 12)"
        fill={color || "#0075bb"}
      />
    </svg>
  );
}
